import React from "react";
import css from "./sideList.module.scss";
const BrowserRouter = require("react-router-dom").BrowserRouter;
const Route = require("react-router-dom").Route;
const Link = require("react-router-hash-link").NavHashLink;

export default class SideList extends React.Component<any, any> {
    data = [
        {
            label: "Home",
            hash: '#home',
            children: []
        }, {
            label: "Work",
            hash: '#work',
            children: [
                {
                    label: "Thales",
                    hash: '#thales'
                },
                {
                    label: "Self-employed",
                    hash: '#selfEmployed'
                }, {
                    label: "MyDigiFlat",
                    hash: '#myDigiFlat'
                },
            ]
        }, {
            label: "Internships",
            hash: '#internships',
            children: [
                {
                    label: "Supplier Portal",
                    hash: '#supplierPortal'
                }, {
                    label: "Payroll",
                    hash: '#payroll'
                }, {
                    label: "Code Lustre Generator",
                    hash: '#lustre'
                },
            ]
        }, {
            label: "Side Projects",
            hash: "#sideProjects",
            children: [
                {
                    label: "zLand",
                    hash: "#zLand"
                }, {
                    label: "offer.tn",
                    hash: "#offerTn"
                }, {
                    label: "Go To Source",
                    hash: "#goToSource"
                }, {
                    label: "Save Data",
                    hash: "#save_data"
                }, {
                    label: "Update Backup Disk",
                    hash: "#update_backup_disk"
                }, {
                    label: "Fetch & Get",
                    hash: "#fg"
                }, {
                    label: "Mario Sokoban",
                    hash: "#marioSokoban"
                }
            ]
        }, {
            label: "Awards",
            hash: "#awards",
            children: [
                {
                    label: "PSM1",
                    hash: '#psm1'
                }, {
                    label: "Spring Challenge 2021",
                    hash: '#spring_challenge_2021'
                }, {
                    label: "TCPC",
                    hash: "#tcpc"
                }
            ]
        }, {
            label: "Education",
            hash: "#study",
            children: []
        }
    ]

    render() {
        return <BrowserRouter>
            <Route path='/' exact render={
                () => (<div className={css.container}>
                    <ul>
                        {
                            this.data.map(section => <li>
                                <Link to={{path: '/', hash: section.hash}}
                                      style={{fontWeight: "600"}}
                                      scroll={(el: any) =>
                                          el.scrollIntoView({behavior: 'smooth',block: 'start'})
                                      }>
                                    {section.label}
                                </Link>
                                <ul>
                                    {
                                        section.children.map(
                                            card => <li>
                                                <Link to={{path: '/', hash: card.hash}}
                                                      style={{fontSize: "11pt", fontWeight: "600"}}
                                                      scroll={(el: any) =>
                                                          el.scrollIntoView({behavior: 'smooth',block: 'start'})
                                                }>
                                                    {card.label}
                                                </Link>
                                            </li>
                                        )
                                    }
                                </ul>
                            </li>)
                        }
                    </ul>
                </div>)
            }>
            </Route>
        </BrowserRouter>
    }
}